import axios from "axios";
import { Toast, Dialog } from "vant";
import {
  setAccessToken,
  setRefreshToken,
  getRefreshToken,
  getAccessToken
} from "@/utils/auth";

import { reFreshAccessTokenFun } from "@/api/WebLoginRoki";
import { repeatUseRequestFun } from "@/api/lotteryDraw";
import router from "../router";
axios.defaults.withCredentials = true;
axios.defaults.timeout = 20000;
// 创建axios实例
const current = process.env.NODE_ENV;
export const prexUrlLink =
  current == "development" || current == "testing"
    ? "http://developh5.myroki.com"
    : "https://h5.myroki.com";
export const preUrlLink =
  current == "development" || current == "testing"
    ? "http://develop.h5.myroki.com/dist/index.html#"
    : "https://h5.myroki.com/dist/index.html#";
export const urlLink =
  current == "development" || current == "testing"
    ? "https://developh5.myroki.com/distkitch/index.html#"
    : "https://h5.myroki.com/distkitch/index.html#"; //打包之后指向的地址（正式---oss上）---测试地址为http://develop.h5.myroki.com/distkitch/index.html#/
export const urlLinkAg =
  current == "development" || current == "testing"
    ? "http://develop.h5.myroki.com/#"
    : "https://h5.myroki.com/#";
export const newUrlLink =
  current == "development" || current == "testing"
    ? "https://developh5.myroki.com/distRokiAct/index.html#"
    : "https://h5.myroki.com/distRokiAct/index.html#";
var baseUrl = "";
var rewardBaseUrl = ""; //rewardapi
//var baseUrl='https://api.myroki.com';
// var rewardBaseUrl='https://cook.myroki.com';

if (current == "development" || current == "testing") {
  baseUrl = "https://api-test.myroki.com";
  rewardBaseUrl = "https://cook-api-test.myroki.com";
  // baseUrl = 'https://api.myroki.com';
  // rewardBaseUrl = 'https://cook.myroki.com';
} else {
  baseUrl = "https://api.myroki.com";
  rewardBaseUrl = "https://cook-api.myroki.com";
}
 
export const regularReq = config => {
  //返回promise对象
  return new Promise((resolve, reject) => {
    //创建axios实例，把基本的配置放进去
    // let sessionToken =
    const instance = axios.create({
      //定义请求文件类型
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      timeout: 20000,
      //定义请求根目录
      baseURL: process.env.NODE_ENV == "development" ? "/api" : baseUrl
    });
    instance.interceptors.request.use(
      config => {
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );
    //请求成功后执行的函数
    instance(config)
      .then(res => {
        console.log("request-----res----", res);
        const code = res.data.rc;
        if (code === 0) {
          resolve(res.data);
        } else {
          const errMsg =
            res.data.msg ||
            res.data.error_description ||
            res.data.error ||
            "未知错误";
          Toast.fail(errMsg);
          reject("error");
        }
      })
      .catch(err => {
        //失败后执行的函数
        //console.log(err);
        if (
          err.response &&
          err.response.data &&
          err.response.data.error_description
        ) {
          Toast.fail(err.response.data.error_description);
        } else {
          Toast.fail("请求异常");
        }
        //Toast.fail('请求异常');
        reject(err);
      });
  });
};
export const loginReq = config => {
  //返回promise对象
  return new Promise((resolve, reject) => {
    //创建axios实例，把基本的配置放进去
    // let sessionToken =
    const instance = axios.create({
      //定义请求文件类型
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Cache-Control": "no-cache"
      },
      // timeout: 3000,
      //定义请求根目录
      baseURL: process.env.NODE_ENV == "development" ? "/api" : baseUrl
    });
    //请求成功后执行的函数
    instance(config)
      .then(res => {
        console.log("login-res----", res);
        resolve(res.data);
      })
      .catch(err => {
        // debugger //失败后执行的函数
        //console.log(err.response.data);
        if (
          err.response &&
          err.response.data &&
          err.response.data.error_description
        ) {
          Toast.fail(err.response.data.error_description);
        } else {
          Toast.fail("请求异常");
        }
        reject(err);
      });
  });
};
export const rewardRegularReq = config => {
  //返回promise对象
  return new Promise((resolve, reject) => {
    //创建axios实例，把基本的配置放进去
    // let sessionToken =
    const currentClient = localStorage.getItem("terminal");
    const userInfo = JSON.parse(localStorage.getItem("userInfokey"));
    let userId = "",
      terminalLoginToken = "";
    try {
      if (currentClient == "app") {
        userId = localStorage.getItem("terminalUserId") || "";
        terminalLoginToken = JSON.parse(
          localStorage.getItem("terminalLoginToken")
        );
      } else {
        userId = userInfo && userInfo.id ? userInfo.id : "";
        terminalLoginToken = getAccessToken();
      }
    } catch (err) {}
    const instance = axios.create({
      //定义请求文件类型
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        clientId: currentClient == "app" ? "roki_client" : "roki_h5_client",
        userId: userId || "",
        accessToken: terminalLoginToken || ""
      },
      // timeout: 3000,
      //定义请求根目录
      baseURL:
        process.env.NODE_ENV == "development" ? "/cook" : `${rewardBaseUrl}` //"/cook/api-cook-manage"
    });

    // request interceptor
    instance.interceptors.request.use(
      config => {
        return config;
      },
      error => {
        // do something with request error
        console.log(error); // for debug
        return Promise.reject(error);
      }
    );
    // 响应拦截器
    instance.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        return Promise.reject(error);
      }
    );
    //请求成功后执行的函数
    instance(config)
      .then(res => {
        console.log("request-----res----", res);
        const code = res.data.code;
        if (code === 200) {
          resolve(res.data);
        } else if (code === 401) {
          //access_token过期之后--重新刷新refresh_token
          if (localStorage.getItem("terminal") != "app") {
            const refreshToken = getRefreshToken();
            const data = {
              client_id: "roki_h5_client",
              client_secret: "test",
              refresh_token: refreshToken
            };
            reFreshAccessTokenFun(data)
              .then(response => {
                if (response.access_token) {
                  const date = new Date(
                    new Date().getTime() + response.expires_in * 1000
                  );
                  setAccessToken(response.access_token, date);
                  setRefreshToken(response.refresh_token, 180);
                  repeatUseRequestFun(config)
                    .then(r => {
                      console.log("rrrrrr----", r);
                      resolve(r);
                    })
                    .catch(failobj => {
                      //Toast.fail('登录过期,请重新登录')
                      Dialog.confirm({
                        title: "提示",
                        message: "登录过期,请重新登录"
                      }).then(() => {
                        // on confirm
                        console.log("router", router);
                        router.push("/login");
                      });
                      reject("error");
                    });
                } else {
                  // Toast.fail('登录过期,请重新登录')
                  Dialog.confirm({
                    title: "提示",
                    message: "登录过期,请重新登录"
                  }).then(() => {
                    // on confirm
                    console.log("router", router);
                    router.push("/login");
                  });
                  reject("error");
                }
              })
              .catch(failobj => {
                //Toast.fail('登录过期,请重新登录')
                Dialog.confirm({
                  title: "提示",
                  message: "登录过期,请重新登录"
                }).then(() => {
                  // on confirm
                  console.log("router", router);
                  router.push("/login");
                });
                reject("error");
              });
          } else {
            reject("error");
          }
        } else {
          const errMsg =
            res.data.message ||
            res.data.msg ||
            res.data.error_description ||
            res.data.error ||
            "未知错误";
          Toast.fail(errMsg);
          reject("error");
        }
      })
      .catch(err => {
        //失败后执行的函数
        // Toast.fail('请求异常');
        reject(err);
      });
  });
};
export const rewardReqWithoutLogin = config => {
  //返回promise对象
  return new Promise((resolve, reject) => {
    //创建axios实例，把基本的配置放进去
    // let sessionToken =
    const instance = axios.create({
      //定义请求文件类型
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      // timeout: 3000,
      //定义请求根目录
      baseURL:
        process.env.NODE_ENV == "development" ? "/cook" : `${rewardBaseUrl}`
    });
    //console.log('config-----config-----',config)
    // request interceptor
    instance.interceptors.request.use(
      config => {
        return config;
      },
      error => {
        // do something with request error
        console.log(error); // for debug
        return Promise.reject(error);
      }
    );
    // 响应拦截器
    instance.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        return Promise.reject(error);
      }
    );
    //请求成功后执行的函数
    instance(config)
      .then(res => {
        console.log("request-----res----", res);
        const code = res.data.code;
        if (code === 200) {
          resolve(res.data);
        } else {
          const errMsg =
            res.data.message ||
            res.data.msg ||
            res.data.error_description ||
            res.data.error ||
            "未知错误";
          Toast.fail(errMsg);
          reject("error");
        }
      })
      .catch(err => {
        //失败后执行的函数
        //Toast.fail('请求异常');
        reject(err);
      });
  });
};



// WEBPACK FOOTER //
// ./src/utils/request.js